export default {
  all: [],
  lastEvaluatedKey: null,
  loadAll: false,
  one: {

  },
};
